import {colors} from 'shells/colors/colors';
import {ArrowDownThinIcon} from 'shells/icon/svg/arrow-down-thin-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowUpIcon} from 'shells/icon/svg/arrow-up-icon';
import {ReturnIcon} from 'shells/icon/svg/return-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {KeyboardKey} from './keyboard-key';

export const KeyboardShortcuts = () => (
    <>
        <Stack spacing={4} isHorizontal alignItems='center'>
            <KeyboardKey>
                <ArrowUpIcon color={colors.greyLt} size={10} />
            </KeyboardKey>
            <KeyboardKey>
                {/* @ts-expect-error */}
                <ArrowDownThinIcon color={colors.greyLt} size={10} />
            </KeyboardKey>
            <Body size='small' color='light'>
                Navigate
            </Body>
        </Stack>
        <Stack spacing={4} isHorizontal alignItems='center'>
            <KeyboardKey>
                {/* @ts-expect-error */}
                <ReturnIcon color={colors.greyLt} size={10} />
            </KeyboardKey>
            <Body size='small' color='light'>
                Select
            </Body>
        </Stack>
        <Stack spacing={4} isHorizontal alignItems='center'>
            <KeyboardKey width={24}>
                <Body size='small' color='light'>
                    esc
                </Body>
            </KeyboardKey>
            <Body size='small' color='light'>
                Close
            </Body>
        </Stack>
    </>
);
